'use client';

import { BridgeWidget } from 'mode-shared/components/bridge/BridgeWidget';
import Link from 'next/link';

export default function BridgePage() {
  return (
    <div className="flex flex-col gap-y-4 w-fit mx-auto">
      <BridgeWidget />
      <Link
        className="font-sans underline underline-offset-2 font-medium text-xs text-neutral-100"
        target="_blank"
        href="https://www.mode.network/bridges"
      >
        Explore more options
      </Link>
    </div>
  );
}
